import React, { Component } from "react";

import withAuthorization from "./withAuthorization";
import { db } from "../firebase";


class HomePage extends Component {
  state = {
    users: null,
    username: "",
    loading: true
  };

  componentDidMount() {
    // db.onceGetUsers().then(res => {
    //   this.setState({
    //     users: res.val()
    //   });
    // });

    const { loggedUser } = this.props;
    db.doGetAnUnser(loggedUser.uid).once('value', snapshot => {
      this.setState({
        username: snapshot.val().username,
        loading: false
      });
    });
  }

  render() {
    const { users, username, loading } = this.state;

    // console.log("UID by rahul", localStorage.getItem('auth'));
    // console.log("email by rahul", this.props.loggedUser.email);

    db.doGetShopList();

    return (
      <div style={{position: 'fixed'}}>
        <h5>Home</h5>
        {!loading && <p style={{paddingLeft: '20px'}}>Hey {username}!</p>}
        

      
          {/* NOTE: This page is only accessible by signed in users.
          here we have to tell the user about the delivery cost and offers and delivery time */}
        
        <img 
          src={require('./Images/del.PNG')} 
          style={{top: '100px',overflowX: 'none',width: '100%',paddingRight:'10px', height: '100%'}} 
          // overflowY: 'none'
          alt="delivery"/>
        {/* {!!users && <UserList users={users} />} */}
    
      </div>
    );
  }
}

// const UserList = ({ users }) => (
//   <div>
//     {console.log("users", users)}
//     <h2>List of Usernames of Users</h2>
//     <p>(Saved on Sign Up in Firebase Database)</p>

//     {Object.keys(users).map(key => (
//       <div key={key}>{users[key].username}</div>
//     ))}
//   </div>
// );

const authCondition = authUser => !!authUser;

export default withAuthorization(authCondition)(HomePage); //grants authorization to open endpoint if an user is signed in
